import { remoteConfig } from 'lib/firebase'

let startupConfigPromise

const loadStartupConfig = () => {
  if (!startupConfigPromise) {
    startupConfigPromise = Promise.resolve()
      .then(() => remoteConfig.fetchAndActivate())
      .then(() => remoteConfig)

    // The request can finish before React mounts. Keep its rejection handled
    // until the app consumes the same promise and applies its existing fallback.
    startupConfigPromise.catch(() => {})
  }

  return startupConfigPromise
}

// Next loads _app before the page and its dynamic components are ready.
// Overlap that wait with the existing config request, without changing SDK
// cache/timeout settings or allowing the preloader to dismiss before it settles.
if (typeof window !== 'undefined') {
  loadStartupConfig()
}

export default loadStartupConfig
